/* @flow */
import React from 'react'
import { connect } from 'react-redux'
import { push, goBack } from 'react-router-redux'
import { Translate, I18n } from 'react-redux-i18n'
import Select from 'react-select'
import _ from 'lodash'
import moment from 'moment'

import 'react-credit-cards/es/styles-compiled.css'
import './style.css'
import Header from '../../components/Header'
import Button from '../../components/Button'
import Card from '../../components/Card'
import { setCurrentOrder, getOrderById, updateOrder } from '../../actions/order'
import { payByCreditCard } from '../../libs/api'
import { PAYMENT_URL, MERCHANT_ID } from '../../configs/constants'
// import { encryptCreditCard } from '../../libs/utility'

type AccountOrderProps={}
class AccountOrder extends React.Component<AccountOrderProps> {
  idTypes

  state = {
    coupon: null
  }

  constructor(props) {
    super(props)
    this.idTypes = [
      { label: I18n.t('id'), value: 'id' },
      { label: I18n.t('passport'), value: 'passport' },
    ]
  }

  _updateOrder = (event) => {
    const { coupon } = this.state
    const { order, updateOrder } = this.props
    if (coupon) {
      updateOrder({ orderNo: order.orderNo, coupon: coupon.code, discountId: coupon.discountId, discount: coupon.amount })
    }
    // setTimeout(() => {
    //   document.getElementById('paymentForm').submit()
    // }, 1000)
    // event.preventDefault()
  }

  componentDidMount() {
    if (!this.props.order) {
      // const order = sessionStorage.getItem('currentOrder')
      // if (order) {
      //   this.props.setCurrentOrder(JSON.parse(order))
      // } else {
        // this.props.navigate('/')
      const { params, getOrderById } = this.props
      getOrderById(params.orderNo)
      // }
    }
  }

  render() {
    const { order, shops, coupons, account, currency, navigate, locale } = this.props
    const { coupon } = this.state
    if (!account || !order || !shops.length)
      return null

    const couponList = _.reduce(coupons, (list, items, key) => {
      return list.concat(
        _.map(
          _.filter(items, (item) => item.active && moment(item.activatedDate).isSameOrBefore(moment()) && moment(item.expiredDate).isAfter(moment())),
          (item) => ({
            ...item,
            label: item.code + ' (' + I18n.t('expireOn', { date: item.expiredDate }) + ')',
            value: item.amount,
            discountId: key
          })
        )
      )
    }, [])

    const shop = _.find(shops, ['id', order.shopId])
    const { travelers } = order

    // Setup travelers
    let travelerList = []
    if (travelers) {
      for(let i = 0; i < order.peopleCount; i++) {
        let travelerInfo = <React.Fragment>
          <div className="row">
            <Translate value="name" className="label" />：
            <div>{travelers[i].name}</div>
          </div>
          <div className="row">
            <Translate value="birthday" className="label" />：
            <div>{travelers[i].birthday}</div>
          </div>
          <div className="row">
            <div className="label">{travelers[i].idType.label}：</div>
            <div>{travelers[i].id}</div>
          </div>
        </React.Fragment>
        if (order.tags.indexOf('vrtour') < 0) {
          travelerList.push(<Card key={'traveler'+i}>
            <div className="headline">{I18n.t('traveler')+' '+(i+1)}</div>
            { travelerInfo }
          </Card>) 
        }
      }
    }
    const now = new Date().getTime()
    const amount = Math.ceil(order.peopleCount * order.price * currency.ratio * 100) / 100 - (coupon ? coupon.amount : 0)
    const orderDesc = [order.name[locale], (coupon ? I18n.t('useCouponDiscount', { amount: coupon.amount }) : '')].join(' ')
    // Build payment info
    const { tradeInfo, tradeSha } = payByCreditCard(
      now,
      order.orderNo,
      amount,
      orderDesc,
      account.email,
    )

    const discountInfo = (coupon ? (" (" + I18n.t('useCoupon') + ": " + coupon.amount + ")") : "") ||
      (order.discount ? (" (" + I18n.t('useCoupon') + ": " + order.discount + ")") : "")

    return <div className="order-container">
      <Button type="action"
        text={I18n.t('backToAccount')}
        onClick={(e) => navigate('/account/orders')}
      />
      <Header title="yourOrder" />
      <Card>
        <div className="row">
          <Translate value="activity" className="label" />：
          <div className="title">
            <span className="subtitle">{shop.name[locale]}</span>
            {order.name[locale]}
          </div>
        </div>
        <div className="row">
          <Translate value="time" className="label" />：
          <div className="title">
            {order.startDate + (order.endDate !== order.startDate ? (' - ' + order.endDate) : '') + ' ' + (order.timeSection && order.timeSection !== -1 ? order.timeSection : '')}
          </div>
        </div>
        <div className="row">
          <Translate value="persons" className="label" />：
          <div className="title">
            {order.peopleCount}
            <Translate value="people" />
          </div>
        </div>
        <div className="row">
          <Translate value="charge" className="label" />：
          <div className="title">
            {
              currency.label.toUpperCase() + ' ' + Math.ceil(order.peopleCount * order.price * currency.ratio * 100) / 100
              + discountInfo
            }
          </div>
        </div>
        <div className="row">
          <Translate value="accountsPayable" className="label" />：
          <div className="title">
            {
              currency.label.toUpperCase() + ' ' + (Math.ceil(order.peopleCount * order.price * currency.ratio * 100) / 100 - (order.discount ? order.discount : 0))
            }
          </div>
        </div>
      </Card>
      { order.tags.indexOf('vrtour') < 0 && (
        <React.Fragment>
          <Header title="travelerInfo" comment={"travelInsurance"} />
          <form onSubmit={this.onSubmit}>
            { _.map(travelerList, (traveler) => traveler) }
          </form>
        </React.Fragment>
      )}
      <Header title="contactInfo" />
      <Card>
        <div className="row">
          <Translate value="name" className="label" />：
          <div className="title">
            {order.contact.name}
          </div>
        </div>
        <div className="row">
          <Translate value="phone" className="label" />：
          <div className="title">
            {order.contact.phone}
          </div>
        </div>
        <div className="row">
          <Translate value="email" className="label" />：
          <div className="title">
            {order.contact.email}
          </div>
        </div>
      </Card>
      {
        order.status === 'unpaid' &&
        <div className="extension">
          <div className="row">
            <Translate value="useCoupon" className="label" />
          </div>
          <div className="row">
            <Select
              className="select-front"
              clearable={true}
              name="fCoupon"
              value={coupon}
              onChange={(selected) => this.setState({ coupon: selected })}
              options={couponList}
            />
          </div>
          <form id="paymentForm" method="post" action={PAYMENT_URL} onSubmit={this._updateOrder}>
            <input type="hidden" name="MerchantID" value={MERCHANT_ID}/>
            <input type="hidden" name="RespondType" value="JSON"/>
            <input type="hidden" name="TimeStamp" value={now}/>
            <input type="hidden" name="TradeInfo" value={tradeInfo}/>
            <input type="hidden" name="TradeSha" value={tradeSha}/>
            <input type="hidden" name="Version" value="1.4"/>
            <input type="hidden" name="MerchantOrderNo" value={order.orderNo}/>
            <input type="hidden" name="Amt" value={amount}/>
            <input type="hidden" name="ItemDesc" value={orderDesc}/> 
            <input type="hidden" name="Email" value={account.email}/>
            <input type="hidden" name="LoginType" value="0"/>
            <input type="hidden" name="CREDIT" value="1"/>
            <input type="submit" className="submit" value={I18n.t('payNow')} />
          </form>
        </div>
      }
      {
        order.coupon && order.status !== 'unpaid' &&
        <div className="extension">
          <div className="row">
            <Translate value="useCoupon" className="label" />
          </div>
          <div className="row">
            <input type="text" value={order.coupon} readOnly />
          </div>
        </div>
      }
      {/* { order.creditCard && order.creditCard.number &&
        <Header title="creditCardInfo" comment="creditCardInfoComment" />
      }
      { order.creditCard && order.creditCard.number &&
        <Card>
          <div className="row">
            <Translate value="cardNo" className="label" />：
            <div>{encryptCreditCard(order.creditCard.number)}</div>
          </div>
        </Card>
      } */}
    </div>
  }
}

const mapStateToProps = (state, ownProps) => ({
  account: state.global.user,
  coupons: state.discount.coupons,
  order: state.order.current,
  shops: state.shop.shops,
  currency: state.global.currency,
  locale: state.i18n.locale,
  params: ownProps.match.params,
})
const mapDispatchToProps = (dispatch) => ({
  navigate: (location) => dispatch(push(location)),
  goBack: () => dispatch(goBack()),
  setCurrentOrder: (order) => dispatch(setCurrentOrder(order)),
  getOrderById: (id) => dispatch(getOrderById(id)),
  updateOrder: (order) => dispatch(updateOrder(order)),
})
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountOrder)


// WEBPACK FOOTER //
// ./src/containers/AccountOrder/index.js